 <template>
     <div>
        <edit-content-modal
            v-model="show_content_dialog"
            :modelProp="contents.market_place"
            :constants="constants"
            refElement="market_place"
            @updatedContent="updateContent"
        />

        <v-form name="editForm" ref="editForm">

            <h4 class="tw-text-secondary mt-3 mb-3">Market Place</h4>

            <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-4">
                <div class="tw-w-1/2 pl-9">
                    <p class="description" ref="market_place" v-html="$root.sanitizeAndTruncateHTML(contents.market_place.body, 1000)"></p>
                    <v-btn :loading="saveLoading" class="mr-2 main-btn" @click="editContentModal('show_content_dialog')">Edit Market Place Body</v-btn>
                </div>
            </div>

            <v-divider class="my-4"></v-divider>

            <div class="tw-flex tw-justify-end">
                <v-btn :loading="saveLoading" :disabled="isEmptyUpload" class="main-btn" @click="uploadFiles">Upload</v-btn>
            </div>

        </v-form>
    </div>

</template>

<script>
import EditContentModal from "@/Modals/EditContentModal.vue";

export default {
    name: "WebsiteContentMarketplaceContents",
    components: {
        EditContentModal
    },
    props: {
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'contents': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        }
    },
    data() {
        return {
            show_content_dialog: false,
            modelObject: {},
            saveLoading: false,
        }
    },
    mounted() {
        //
    },
    computed: {
        isEmptyUpload() {
            //return Object.keys(this.modelObject).length === 0
            return !Object.values(this.modelObject).some(value => value !== null);
        }
    },
    methods: {
        emptyUpload() {
            for (let key in this.modelObject) {
                this.modelObject[key] = null
            }
        },
        editContentModal(editor) {
            this[editor] = true
        },
        updateContent(content, ref) {
            if (!ref) {
                return;
            }
            if (!this.$refs[ref]) {
                return;
            }
            this.$refs[ref].innerHTML = content;
        },
    }
}
</script>
 <style scoped>
 .description {
     font-size: 0.9em;
 }
 </style>
